<ng-container *ngIf="group && field">

  <div class="main-outer-container " [formGroup]="group" [hidden]="field.hidden || false">





    <div class="flex align-top my-2 flex-col">
      <label for="{{field!.name}}" [hidden]="field!.hidden ? field!.hidden: false"
        class="label col-sm-3 col-form-label">{{field!.label}}
      </label>

      <mat-radio-group #radio [name]="field.name" [formControlName]="field.name" (change)="changes($event)">

        <div class="flex flex-row" *ngIf="this.options?.api">
          <div *ngFor="let choice of data | async, let index" class="mr-2 w-auto">

            <mat-radio-button [id]="choice.id" [value]="choice.id">{{choice.codice}}</mat-radio-button>
            <img *ngIf="choice.pathToImg.length >0" [src]="choice.pathToImg" width="200px" height="200px">
          </div>
        </div>

        <div class="flex flex-row" *ngIf="!this.options?.api">
          <div *ngFor="let choice of data, let index" class="mr-2 w-auto">

            <mat-radio-button [id]="choice.id" [value]="choice.id">{{choice.codice}}</mat-radio-button>
            <img *ngIf="choice.pathToImg && choice.pathToImg.length >0" [src]="choice.pathToImg" width="200px" height="200px">
          </div>
        </div>
      </mat-radio-group>
    </div>

    <!-- <label for="{{field!.name}}"
          class="label col-sm-3 col-form-label">{{field.label}}</label> -->

    <!--OLD [class]="group.controls[field!.name].dirty ? (group.controls[field.name].invalid ? 'danger' : 'success') : ''"
        [attr.aria-invalid]="group.controls[field.name].invalid && group.controls[field.name].touched
                      ? true : null" (change)="onChangeValue($event)"
        -->
    <!-- <ejs-tooltip [target]="'#'+field.name" [content]="field.tooltip" (beforeOpen)="beforeTooltipOpen($event)" >
            
          </ejs-tooltip> -->


    <div *ngIf="field.message!=undefined">
      <p class="text-sm">{{field.message}}</p>
    </div>
    <!--OLD ngIf *ngIf="group.controls[field.name].dirty && group.controls[field.name].invalid"-->
    <div class="flex align-top flex-col"
      *ngIf="group.controls[field.name]?.dirty || group.controls[field.name]?.touched">
      <ng-container *ngFor="let validation of field!.validations;let i= index;">
        <div @slideDownUp *ngIf="group && field && group.controls[field.name].hasError(validation.name)"
          class=" p-2 flex justify-start items-center gap-2 bg-red-700/50 rounded-xl text-white font-bold">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>

          <p>{{validation.message}}</p>
        </div>
      </ng-container>

    </div>

  </div>
</ng-container>